import React, {Fragment, useCallback, useEffect, useMemo, useState} from "react"
import {useSelector} from "react-redux"
import {StateType} from "../../store/store"
import {getMoreNotifications, getNotifications, getNotViewedNotificationsCount, setViewedNotifications} from "../../store/appReducer"
import {Button, Divider, Drawer} from "antd"
import {BellIcon} from "./BellIcon"
import {NavLink} from "react-router-dom"
import s from "./headerNotification.module.scss"
import {catchError} from "../../store/sliceHelper"
import moment from "moment"
import {NotificationType} from "../../models/response"

const getColor = (type: NotificationType) =>
{
    switch (type)
    {
        case "info":
            return "#79c6ff"
        case "success":
            return "#19ff1c"
        case "warning":
            return "#ffca1a"
        case "error":
            return "#ff1a1a"
        case "default":
            return "#b6b6b6"
        default:
            return "#b6b6b6"
    }
}

const limit = 100

type Props = {
    dispatch: any
    controller: AbortController
}
export const HeaderNotification: React.FC<Props> = ({dispatch, controller}) =>
{
    const notifications = useSelector((state: StateType) => state.appReducer.notifications)
    const [open, setOpen] = useState(false)
    const [offset, setOffset] = useState(0)
    const [loading, setLoading] = useState(false)

    const showDrawer = () =>
    {
        dispatch(getMoreNotifications({limit: limit, offset: 0, controller, withoutLoadingIndicator: true}))
        setOpen(true)
        if (typeof window !== "undefined" && window.document)
        {
            document.body.style.overflowY = "hidden"
        }
    }

    const onClose = useCallback(() =>
    {
        setOpen(false)
        document.body.style.overflowY = "unset"
    }, [])

    const setAllViewed = async () =>
    {
        try
        {
            setLoading(true)
            dispatch(setViewedNotifications({controller}))
            dispatch(getNotifications({controller}))
            onClose()
        } catch (e: any)
        {
            catchError(e, dispatch)
        } finally
        {
            setLoading(false)
        }
    }

    const setViewed = useCallback(async (id: number) =>
    {
        try
        {
            onClose()
            dispatch(setViewedNotifications({id, controller}))
        } catch (e: any)
        {
            catchError(e, dispatch)
        }
    }, [dispatch, onClose, controller])

    useEffect(() =>
    {
        dispatch(getNotViewedNotificationsCount({limit: 1, offset: 0, controller}))
    }, [dispatch, controller])

    const getMoreNotificationsFunc = useCallback(() =>
    {
        dispatch(getMoreNotifications({limit: limit, offset: offset + limit, controller}))
        setOffset(prev => prev + limit)
    }, [dispatch, offset, controller])

    const items = useMemo(() => notifications?.data && notifications?.data.map((item, index) =>
    {
        const date = <div style={{textAlign: "center", marginTop: 10, marginBottom: 10, fontWeight: "bold", color: "#676767"}}>{moment(item.createdAt).format("DD.MM.YYYY")}</div>

        return (
            <Fragment key={item.id}>
                {
                    index === 0 || moment(notifications.data[index - 1].createdAt).format("DD.MM.YYYY") !== moment(item.createdAt).format("DD.MM.YYYY")
                        ? date
                        : null
                }
                <Divider style={{margin: 0}}/>
                <NavLink to={item.link}
                         onClick={async () => await setViewed(item.id)}
                         style={{fontWeight: "bold", borderLeftStyle: "solid", borderLeftColor: getColor(item.type), borderLeftWidth: 8}}
                         className={s.notificationItem}
                >
                    <div>{item.description}</div>
                    <div style={{fontSize: 12, color: "#949494"}}>{moment(item.createdAt).format("HH:mm")}</div>
                </NavLink>
                {index === notifications.data.length - 1 ? <Divider style={{margin: 0}}/> : null}

                {
                    index === notifications.data.length - 1 && index < notifications.total - 1
                        ? <Button onClick={getMoreNotificationsFunc}
                                  style={{margin: "20px 10px 10px 10px"}}
                                  loading={loading}
                        >
                            Загрузить ещё
                        </Button>
                        : null
                }
            </Fragment>
        )
    }), [notifications, setViewed, getMoreNotificationsFunc, loading])

    return (
        <div>
            <div onClick={showDrawer} style={{margin: "5px 15px"}}>
                <BellIcon count={notifications?.total}/>
            </div>

            <Drawer title="Уведомления"
                    placement="right"
                    width={500}
                    onClose={onClose}
                    open={open}
                    extra={
                        notifications?.data && notifications.data.length > 0
                            ? <Button onClick={async () => await setAllViewed()}
                                      loading={loading}
                            >
                                Отметить все как просмотренные
                            </Button>
                            : null
                    }
                    bodyStyle={{padding: 10}}
            >
                <div style={{display: "flex", flexDirection: "column"}}>
                    {items}
                </div>
            </Drawer>
        </div>
    )
}


